/* Biomed - Aggiunta al carrello su mobile con il tema impostato su "Pagina".
   Con "Azione dopo aggiunta al carrello su desktop = Pagina" il tema Purity non inserisce il <cart-drawer>
   nella pagina. Sotto i 768 px, dopo /cart/add, il tema chiama this.cart.renderContents(): this.cart e' null,
   il prodotto viene aggiunto ma il cliente vede "Si e' verificato un errore durante l'aggiornamento del carrello".
   Qui intercettiamo il submit prima del tema, aggiungiamo via /cart/add.js e andiamo alla pagina carrello,
   lo stesso comportamento del desktop. Non fa nulla se il cassetto esiste o se siamo gia' nel carrello. */
(function () {
  'use strict';

  function needsFix() {
    return window.innerWidth <= 767 &&
      !document.querySelector('cart-drawer') &&
      !document.body.classList.contains('template-cart');
  }

  function showError(form, message) {
    var host = form.closest('product-form') || form;
    var wrapper = host.querySelector('.product-form__error-message-wrapper');
    var text = host.querySelector('.product-form__error-message');
    if (wrapper && text) { text.textContent = message; wrapper.removeAttribute('hidden'); return; }
    var el = document.createElement('p');
    el.className = 'bm-add-error';
    el.setAttribute('role', 'alert');
    el.style.cssText = 'margin:.8rem 0 0;color:#c0392b;font-size:1.3rem;';
    el.textContent = message;
    form.appendChild(el);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (!form.closest('product-form')) return;
    if (!needsFix()) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var btn = event.submitter || form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    var idField = form.querySelector('[name="id"]');
    if (idField) idField.disabled = false;

    var fd = new FormData(form);
    fd.delete('sections'); fd.delete('sections_url');

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Cart update failed');
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'bm_mobile_add_redirect', variant: fd.get('id') }); } catch (e) {}
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      })
      .catch(function (e) {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
        var fallback = (window.cartStrings && window.cartStrings.error) || 'Si è verificato un errore, riprova.';
        showError(form, (e && e.message && e.message !== 'Cart update failed') ? e.message : fallback);
      });
  }, true);
})();
